import React from "react";
import callUsIcon from "../Images/9946341.png";

const CallUsButton = () => {
  const buttonStyle = {
    position: "fixed",
    bottom: "45px",
    left: "40px",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    cursor: "pointer",
  };
  const iconStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
  };
  return (
    <div style={buttonStyle}>
      <a href="tel:919834737373">
      <img style={iconStyle} src={callUsIcon} alt="" />
      </a>
    </div>
  );
};

export default CallUsButton;
